// extracted by mini-css-extract-plugin
export var active = "index-module--active--9Os7+";
export var lijst = "index-module--lijst--OsGEZ";
export var lijster = "index-module--lijster--KNiFp";
export var ordered_list = "index-module--ordered_list--CTVoD";